module.exports = __webpack_public_path__ + "img/Weapon_285.f92b62df.png";